import MoeAbboud from "../../assets/headshots/MoeAbboud.jpg"
import MoeChami from "../../assets/headshots/MoeChami.jpg"
import JesusOrozco from "../../assets/headshots/JesusOrozco.jpg"
import RazanShams from "../../assets/headshots/RazanShams.jpg"
import AbdulKhan from "../../assets/headshots/AbdulKhan.jpg"
import AnikaRaisa from "../../assets/headshots/AnikaRaisa.jpg"
import MouhamedSalma from "../../assets/headshots/MouhamedSalma.jpg"
import GayathriChava from "../../assets/headshots/GayathriChava.jpg"
import HebaSayed from "../../assets/headshots/HebaSayed.jpg"
import Namaa from "../../assets/headshots/Namaa.jpg"
import WhitneyTran from "../../assets/headshots/WhitneyTran.jpg"
import MusaShoeb from "../../assets/headshots/MusaShoeb.jpg"
import MaryamTello from "../../assets/headshots/MaryamTello.jpg"

const devTeamData = [
    {
        imageurl: MaryamTello,
        name: "Maryam Tello",
        linkedIn: "https://www.linkedin.com/in/maryamtello?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        status: "Senior",
    },
    {
        imageurl: AbdulKhan,
        name: "Abdul Khan",
        linkedIn: "https://www.linkedin.com/in/abdulmuiz-khan/",
        status: "Junior",
    },
    {
        imageurl: MoeAbboud,
        name: "Mohamad Abboud",
        linkedIn: "https://www.linkedin.com/in/moeabboud/",
        status: "Junior"
    },
    {
        imageurl: HebaSayed,
        name: "Heba Sayed",
        linkedIn: "https://www.linkedin.com/in/heba-sayed6/",
        status: "Junior",
    },
    {
        imageurl: MoeChami,
        name: "Mohammad El-Chami",
        linkedIn: "https://www.linkedin.com/in/moecham/",
        status: "Sophomore"
    },
    {
        imageurl: JesusOrozco,
        name: "Jesus Orozco",
        linkedIn: "https://www.linkedin.com/in/eisaa-orozco/",
        status: "Junior",
    },
    {
        imageurl: RazanShams,
        name: "Razan Shams",
        linkedIn: "https://www.linkedin.com/in/razan-shams-5a6b072ba/",
        status: "Freshman",
    },
    {
        imageurl: AnikaRaisa,
        name: "Anika Raisa",
        linkedIn: "https://www.linkedin.com/in/anikaraisa/",
        status: "Graduate Student",
    },
    {
        imageurl: MouhamedSalma,
        name: "Mouhamed Salma",
        linkedIn: "https://www.linkedin.com/in/mouhamed-salma/",
        status: "Junior",
    },
    {
        imageurl: GayathriChava,
        name: "Gayathri Chava",
        linkedIn: "https://www.linkedin.com/in/cgayathri21f?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        status: "Junior",
    },
    {
        imageurl: Namaa,
        name: "Namaa Mokhtar",
        linkedIn: "https://www.linkedin.com/in/namaa05?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        status: "Sophomore",
    },
    {
        imageurl: WhitneyTran,
        name: "Whitney Tran",
        linkedIn: "https://www.linkedin.com/in/whitneyttran/",
        status: "Junior",
    },
    {
        imageurl: MusaShoeb,
        name: "Musa Shoeb",
        linkedIn: "https://www.linkedin.com/in/musashoeb/",
        status: "Junior",
    },
]
export default devTeamData;
